import React from "react";
import { SECONDPAGE_HOME_H2, SECONDPAGE_HOME_H1 } from "./Homecss";

function FourthPart() {
  return (
    <div style={{ marginTop: "60px" }}>
      <SECONDPAGE_HOME_H1>Time management features</SECONDPAGE_HOME_H1>
      <SECONDPAGE_HOME_H2>
        Track productivity, attendance, and billable hours with a simple <br />
        time tracker and timesheet.
      </SECONDPAGE_HOME_H2>
    </div>
  );
}

export { FourthPart };
